import { signal, effect } from '@angular/core';


export class NetworkStatusService {

  private online = signal(navigator.onLine); //store navigator.onLine in signal
  isOnline = this.online.asReadonly();

  constructor() {
    window.addEventListener('online', () => this.online.set(true));
    window.addEventListener('offline', () => this.online.set(false));

    effect(() => {
      console.log('🌐 Network status:', this.online() ? 'Online' : 'Offline');
    });
  }

}
